export default {
    filterPanel: {
        alignItems: 'center',
        py: 1,
        pr: 3,
        pl: 2,
        flexGrow: 1,
    },
    filtersHolder: {
        flexGrow: 1,
    },
    filterWrapper: {
        width: '25%',
    },
    searchIcon: {
        color: 'primary.main',
    },
    clearSearchIcon: {
        color: 'primary.main',
        cursor: 'pointer',
        '&:hover': { opacity: 0.75 },
    },
    divider: {
        height: '16px',
    },
    filterPanelViewTypeIcon: {
        px: '5px',
    },
};
